<mat-card class="form">
  <ng-content></ng-content>
</mat-card>
